'use client'
import { compactClassName } from '@/components/homepage-october/compact'
import * as React from 'react'
import { ChevronLeft, ChevronRight } from '@/components/homepage-october/lucide'

export function useSwipeSelection(onSwipe: (direction: number) => void, onTakeover?: () => void) {
  const start = React.useRef<{ x: number; y: number; id: number } | null>(null)
  const dragged = React.useRef(false)
  return {
    style: { touchAction: 'pan-y' } as React.CSSProperties,
    onPointerDown: (e: React.PointerEvent<HTMLElement>) => {
      if (!e.isPrimary || e.button !== 0) return
      onTakeover?.()
      dragged.current = false
      start.current = { x: e.clientX, y: e.clientY, id: e.pointerId }
    },
    onPointerMove: (e: React.PointerEvent<HTMLElement>) => {
      const from = start.current
      if (!from || from.id !== e.pointerId) return
      const dx = e.clientX - from.x, dy = e.clientY - from.y
      if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        dragged.current = true
        e.currentTarget.setPointerCapture(e.pointerId)
        e.preventDefault()
      }
    },
    onPointerUp: (e: React.PointerEvent<HTMLElement>) => {
      const from = start.current
      start.current = null
      if (!from) return
      const dx = e.clientX - from.x, dy = e.clientY - from.y
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) onSwipe(dx < 0 ? 1 : -1)
    },
    onPointerCancel: () => { start.current = null },
    onDragStartCapture: (e: React.DragEvent) => e.preventDefault(),
    onClickCapture: (e: React.MouseEvent) => { if (dragged.current) { e.preventDefault(); e.stopPropagation(); dragged.current = false } },
  }
}
export function RotationControls({ label, onMove }: { label: string; paused: boolean; reduced: boolean; onPause: () => void; onMove: (direction: number) => void }) {
  return <div className={compactClassName("v3-rotation-controls")} role="group" aria-label={label}>
    <button type="button" aria-label={`Previous: ${label}`} onClick={() => onMove(-1)}><ChevronLeft size={16} aria-hidden="true" /></button>
    <button type="button" aria-label={`Next: ${label}`} onClick={() => onMove(1)}><ChevronRight size={16} aria-hidden="true" /></button>
  </div>
}
